// :: Templates ------------ //
import archives from '@templates/Archives.js'
import staffDirectory from '@templates/StaffDirectory.js'
import resources from '@templates/Resources.js'
import docs from '@templates/Documents.js'

// :: Blocks ------------ //
import scrollingShowcase from '@blocks/ScrollingShowcase.js'
import anchor from '@blocks/Anchor.js'

// :: Modules ------------ //
import emailCapture from '@modules/EmailCapture.js'
import header from '@modules/Header.js'
import heroFoundation from '@modules/heroHome/Foundation.js'
import heroTeams from '@modules/heroHome/Teams.js'
import heroTeamsInner from '@modules/HeroTeamsInner.js'
import lightboxCards from '@modules/LightboxCards.js'
import lightboxVideo from '@modules/LightboxVideo.js'
import menu from '@modules/Menu.js'
import popupModal from '@modules/PopupModal.js'
import video from '@modules/Video.js'
import alert from '@modules/Alert.js'

import backgroundReveal from '@components/BackgroundReveal.js'
import backgroundZoomOut from '@components/BackgroundZoomOut.js'
import button from '@components/Button.js'
import buttonSecondary from '@components/ButtonSecondary.js'
import cookieConsent from '@components/CookieConsent.js'
import fadeIn from '@components/FadeIn.js'
import fadeOut from '@components/FadeOut.js'
import linesUp from '@components/LinesUp.js'
import ministryButton from '@components/MinistryButton.js'
import morph from '@components/Morph.js'
import parallax from '@components/Parallax.js'
import parallaxBackground from '@components/ParallaxBackground.js'
import revealer from '@components/Revealer.js'
import spin from '@components/Spin.js'
import translate from '@components/Translate.js'
import wordsUp from '@components/WordsUp.js'
import venn from '@components/Venn.js'
import avalanche from '@components/avalanche/Avalanche'

export default () => {
    // π ----
    // :: UTILITY GLOBALS ---------------------------::
    // ____

    /* :: Remove From Array
    {+} ---------------------------------- */
    window.array = {
        remove(arr, value) {
            return arr.filter(ele => {
                return ele != value
            })
        },
    }

    // :: Templates ------------ //
    window.archives = archives
    window.docs = docs
    window.staffDirectory = staffDirectory
    window.resources = resources

    // :: Blocks ------------ //
    anchor()
    window.scrollingShowcase = scrollingShowcase

    // :: Modules ------------ //
    Alpine.data('header', header)
    Alpine.data('lightboxVideo', lightboxVideo)
    window.emailCapture = emailCapture
    window.heroFoundation = heroFoundation
    window.heroTeams = heroTeams
    window.heroTeamsInner = heroTeamsInner
    window.lightboxCards = lightboxCards
    window.lightboxVideo = lightboxVideo
    window.menu = menu
    window.popupModal = popupModal
    window.videoPlayer = video
    window.alert = alert

    // :: Components ------------ //
    window.backgroundReveal = backgroundReveal
    window.backgroundZoomOut = backgroundZoomOut
    window.button = button
    window.buttonSecondary = buttonSecondary
    window.cookieConsent = cookieConsent
    window.fadeIn = fadeIn
    window.fadeOut = fadeOut
    window.linesUp = linesUp
    window.ministryButton = ministryButton
    window.morph = morph
    window.parallax = parallax
    window.parallaxBackground = parallaxBackground
    window.revealer = revealer
    window.spin = spin
    window.translate = translate
    window.wordsUp = wordsUp
    window.venn = venn

    avalanche()
}
